<template>
  <div class="main">
    <Tabs class="tabs" :tab-list="menuList" title="交易中心" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'trading',
  data() {
    return {
      menuList: [
        {
          routerName: 'trading/list',
          text: '交易订单查询',
        },
        {
          routerName: 'trading/refund',
          text: '退款订单管理',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.main {
  height: 100%;
  .box_column();
}
</style>
